// ============================================================================
// CHECK-OUT SERVICE — read-only history
//
// The write path moved to departureService when departure was separated from
// settlement (PMS phase 1). Rooms depart individually and carry no money; the
// tbl_checkout row is now written by the API when the last room leaves.
// ============================================================================

import { get } from '../client/axiosClient';
import { checkOutEndpoints } from '../endpoints/checkout.endpoints';
import type { ApiResponse, ID } from '../types';
import type { CheckOut } from '../types/checkout.types';

class CheckOutService {
  async getByBooking(bookingId: ID): Promise<CheckOut | null> {
    try {
      const response = await get<ApiResponse<CheckOut>>(checkOutEndpoints.getByBooking(bookingId));
      return response.data?.data ?? null;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  }
}

export const checkOutService = new CheckOutService();
export default checkOutService;
